import React, { lazy } from "react";
import { useSelector } from "react-redux";

const DefaultThemeView = lazy(() => import("./defaultThemeView"));
const VaccinMonitorView = lazy(() => import("./vaccinMonitorView"));

const DefaultTheme = () => {
  const theme = useSelector((state) => state.study.Theme);

  const switchThemes = () => {
    switch (theme) {
      case "darkgreen": {
        return <VaccinMonitorView />;
      }
      case "lightergreen": {
        return <VaccinMonitorView />;
      }
      case "darkorange": {
        return <VaccinMonitorView />;
      }
      default: {
        return <DefaultThemeView />;
      }
    }
  };

  return <React.Fragment>{switchThemes()}</React.Fragment>;
};
export default DefaultTheme;
